export default __webpack_public_path__ + "static/media/circleOnTopRightLight.87ce3ca1.svg";